import "core-js/modules/es.array.push.js";
import "core-js/modules/es.parse-int.js";
import { request } from "@/js/http/http_request";
import { conciergerieTypesRequest } from "@/js/lists.ts";
export default {
  name: "userConciergerie",
  data: function data() {
    return {
      input: {
        conciergerieType: 0,
        message: ""
      },
      errorLabels: {
        subject: "",
        message: ""
      },
      errorMessages: {
        mandatory: "This field is required"
      },
      stepContact: 1,
      conciergerieTypes: conciergerieTypesRequest
    };
  },
  created: function created() {
    var _this$$route$query$me, _this$$route, _this$$route$query$co, _this$$route2;
    this.$EventBus.$emit("loading", false);
    this.input.message = (_this$$route$query$me = (_this$$route = this.$route) === null || _this$$route === void 0 || (_this$$route = _this$$route.query) === null || _this$$route === void 0 ? void 0 : _this$$route.message) !== null && _this$$route$query$me !== void 0 ? _this$$route$query$me : "";
    this.input.conciergerieType = parseInt((_this$$route$query$co = (_this$$route2 = this.$route) === null || _this$$route2 === void 0 || (_this$$route2 = _this$$route2.query) === null || _this$$route2 === void 0 ? void 0 : _this$$route2.conciergerieType) !== null && _this$$route$query$co !== void 0 ? _this$$route$query$co : 0);
  },
  methods: {
    home: function home() {
      this.$router.push({
        name: "userHome"
      });
    },
    makeRequest: function makeRequest() {
      var instance = this;
      if (this.validateInputs()) {
        request("/v1/user/contact", "post", instance.input, true, "api").then(function (response) {
          instance.stepContact = 2;
        }).catch(function (err) {
          instance.$toasted.show("An error occured. Please contact an administrator.", {
            type: "error"
          });
        });
      }
    },
    validateInputs: function validateInputs() {
      this.errorLabels.subject = "";
      this.errorLabels.message = "";
      var valid = true;
      if (this.input.conciergerieType == 0) {
        this.errorLabels.subject = this.errorMessages.mandatory;
        valid = false;
      }
      if (this.input.message == "") {
        this.errorLabels.message = this.errorMessages.mandatory;
        valid = false;
      }
      return valid;
    }
  }
};